export enum ROUTES_STADISTICS {
    STADISTICS = 'main',
    MY_OFFICE = 'my-office',
    MY_DAY = 'my-day'
}
